import { PageOptions } from '@graphcommerce/framer-next-pages'
import { WaitForCustomer, useCustomerQuery } from '@graphcommerce/magento-customer'
import { PageMeta, StoreConfigDocument } from '@graphcommerce/magento-store'
import { GetStaticProps } from '@graphcommerce/next-ui'
import { i18n } from '@lingui/core'
import { LayoutDocument, LayoutNavigation, LayoutOverlayProps } from '../../../components'
import { SubRoleFragment } from '../../../components/Account/SubRole/SubRole.gql'
import { SubRoles } from '../../../components/Account/SubRole/SubRoles'
import { SubRolesDocument } from '../../../components/Account/SubRole/SubRoles.gql'
import { Tabs } from '../../../components/Account/Tabs'
import { graphqlSharedClient } from '../../../lib/graphql/graphqlSsrClient'

function SubRolesPage() {
  const rolesQuery = useCustomerQuery(SubRolesDocument, {
    fetchPolicy: 'cache-and-network',
  })
  const roles = rolesQuery.data?.customer?.sub_roles

  return (
    <div className='w-full'>
      <PageMeta title={i18n._(/* i18n */ 'Manage Roles')} metaRobots={['noindex']} />
      <div className='w-full'>
        <SubRoles
          roles={(roles as SubRoleFragment[]) || []}
          refetch={rolesQuery.refetch}
          loading={rolesQuery.loading}
        />
      </div>
    </div>
  )
}

export default SubRolesPage
